import { cn } from '@virginexperiencedays/tailwind';

import { sanitizeHtml } from '../../../utils/sanitize';

import type { HTMLAttributes } from 'react';

export const HtmlContent = ({
  className,
  content,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { content: string }) => (
  <div
    className={cn(
      'text-neutral text-base leading-normal',
      // links
      '[&_a]:text-neutral [&_a]:hover:text-neutral-strong [&_a]:underline',
      '[&_p_>_a]:text-neutral [&_p_>_a]:hover:text-neutral-strong [&_p_>_a]:underline',
      '[&_li_>_a]:text-neutral [&_li_>_a]:hover:text-neutral-strong [&_li_>_a]:underline',
      // p
      '[&_p+p]:mt-2 [&_p]:mb-0 [&_p]:p-0',
      // list
      '[&_ol]:mb-0 [&_ol]:list-[circle] [&_ol]:pl-6',
      '[&_ul]:mb-0 [&_ul]:list-[circle] [&_ul]:pl-6',
      '[&_li_ol]:mt-2 [&_li_ul]:mt-2',
      // list item
      '[&_ol_li+li]:mt-1 [&_ul_li+li]:mt-1',
      // sibling
      '[&_*_+_*]:mt-2',
      className
    )}
    {...rest}
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) || '' }}
  />
);
